const dateIncrements = {
  ByDay: {
    bottomType: 'day',
    topType: 'month',
    quantity: 1,
  },
  ByWeek: {
    bottomType: 'day',
    topType: 'month',
    quantity: 7,
  },
  ByMonth: {
    bottomType: 'month',
    topType: 'year',
    quantity: 1,
  },
};

export default dateIncrements;
